
import { BaseService } from 'gktapp-service'

const Common = {
    BaseService
};
export default {
    Common
};